// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-puzzles-tsx": () => import("./../../../src/pages/puzzles.tsx" /* webpackChunkName: "component---src-pages-puzzles-tsx" */),
  "component---src-templates-puzzle-tsx": () => import("./../../../src/templates/puzzle.tsx" /* webpackChunkName: "component---src-templates-puzzle-tsx" */)
}

